import { useHoofdleidingGlobalsLists } from './useHoofdleidingGlobalsLists'
import { useHoofdleidingOrganisationLists } from './useHoofdleidingOrganisationLists'

export { useHoofdleidingValuelists }

/** Combines the globals and organisation lists into the shape the filter dropdowns use. */
const useHoofdleidingValuelists = () => {
  const { data: globals } = useHoofdleidingGlobalsLists()
  const { data: organisation } = useHoofdleidingOrganisationLists()

  return {
    data: { ...globals, ...organisation },
  }
}
